class Bookmarks {
  constructor(el) {
    this.container = el
    this.bookmarkButtons = this.container.querySelectorAll('.bookmark')
    this.handleBookmarkRemoval = this.handleBookmarkRemoval.bind(this)
    this.init()
  }

  /**
   * Handles Bookmark Removal
   *
   * @param {HTMLElement} button
   * @param {Event} e
   */
  handleBookmarkRemoval(button, e) {
    e.preventDefault()
    const parent = button.closest('.bookmarks__item')
    if (parent) {
      parent.remove()
    }
  }

  init() {
    if (this.bookmarkButtons.length) {
      this.bookmarkButtons.forEach(btn =>
        btn.addEventListener('bookmark-removed', this.handleBookmarkRemoval.bind(this, btn)),
      )
    }
  }
}

const bookmarkInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.bookmarks')
    Array.from(wrapperEl).forEach(el => new Bookmarks(el))
  },
}

export default bookmarkInit
